module.exports = __webpack_public_path__ + "img/banner25-1.2323329b.jpg";